import Vue from "vue";
import VueI18n from "vue-i18n";
import HanshowUI from "hanshow-ui/locale";
import _ from "lodash";
Vue.use(VueI18n);
const hsLocals = require.context("hanshow-ui/locale/lang", true, /\.js$/);
const hsLocal = hsLocals.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = hsLocals(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
const localesMoudles = require.context(
  "../public/locales",
  true,
  /[A-Za-z0-9-_,\s]+\.json$/i
);
const locales = localesMoudles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = localesMoudles(modulePath);
  modules[moduleName] = value;
  return modules;
}, {});
const defaultMesasge = {};
for (let key in locales) {
  defaultMesasge[key] = {};
  Object.assign(defaultMesasge[key], hsLocal[key], locales[key]);
}
const i18n = new VueI18n({
  locale: window.HS_CONFIG.DEFAULT_LANGUAGE ?? "en",
  fallbackLocale:'en',
  messages: _.cloneDeep(defaultMesasge),
});

HanshowUI.i18n((key, value) => i18n.t(key, value));

const i18nMergeMessage = (messages = {}) => {
  //重置为所有初始内容
  // Object.keys(locales).forEach((locale) => {
  //   i18n.setLocaleMessage(locale, locales[locale]);
  // });
  Object.keys(messages).forEach((lang) => {
    const changeLang = _.merge({}, defaultMesasge[lang], messages[lang]);
    i18n.setLocaleMessage(lang, changeLang);
  });
};

export default i18n;
export { i18nMergeMessage };
